module.exports = __webpack_public_path__ + "img/Northern-Mariana-Islands.2732f973.png";